import { useEffect, useRef, useState } from 'react';

export function useObjectUrl(file: File | null): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!file) {
      setUrl(null);
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    setUrl(objectUrl);

    return () => {
      URL.revokeObjectURL(objectUrl);
    };
  }, [file]);

  return url;
}

export function useObjectUrls(files: (File | null)[]): (string | null)[] {
  const [urls, setUrls] = useState<(string | null)[]>([]);
  const urlsRef = useRef<(string | null)[]>([]);

  useEffect(() => {
    const objectUrls: (string | null)[] = [];

    for (const file of files) {
      if (file instanceof File) {
        objectUrls.push(URL.createObjectURL(file));
      } else {
        objectUrls.push(null);
      }
    }

    urlsRef.current = objectUrls;
    setUrls(objectUrls);

    return () => {
      for (const url of urlsRef.current) {
        if (url) URL.revokeObjectURL(url);
      }
    };
  }, [files]);

  return urls;
}
